/* kn-popup.js — eigen pop-up-engine (vervangt de Klaviyo-pop-ups).
 * Bouwspec: accelerate/POPUP-BOUWSPEC-2026-10-10.md. Config + paginacontext: snippets/kn-popup.liquid.
 *
 * Per pop-up, in deze volgorde:
 *   1. variant   gewogen gekozen, onthouden in sessionStorage (niet blijvend zonder toestemming)
 *   2. mag hij   enabled, planning (startsAt/endsAt, hier gecontroleerd: Liquid-'now' kan uit de cache komen),
 *                template/layout, apparaat, land
 *   3. onderdrukt na inschrijven (nooit meer), na sluiten (N dagen), binnenkomst via een Klaviyo-mail
 *                (utm_source=klaviyo of _kx, hele sessie), ingelogde klant met marketingtoestemming,
 *                Klaviyo kent de bezoeker al (klaviyo.isIdentified, vlak voor openen)
 *   4. triggers  teaser meteen; de modal na delaySec óf scrollPct (wat eerst komt), vanaf minPageviews,
 *                en pas als de cookiebalk weg is (anders ligt de modal over de keuze heen). Binnenkomst via
 *                Google zonder utm: op die landingspagina alleen de teaser, geen modal.
 *   5. modal     role=dialog, aria-modal, focusval, Esc, focus terug, geen back-knop-trucs.
 *                reveal_scratch laadt kn-popup-scratch.js pas nu (lazy).
 *                choice (BF26 pop-up A, Tufan 29-10): eerst één tik op een tegel (copy.choices), dan het e-mailveld;
 *                de keuze gaat als profieleigenschap copy.choiceProp mee naar Klaviyo.
 *                layout "bf": de Black Friday-huisstijl van /pages/black-friday-26 (geel/zwart, Acumin Condensed).
 *   6. inschrijven knKlSub als Promise, lijst + properties uit de config, fout zichtbaar.
 *   7. events    view/teaser_view/reveal/submit/submit_error/close → POST /apps/kn/e (gebundeld, sendBeacon),
 *                dataLayer kn_popup_*, Clarity-tags. Eindpunt weg = stil.
 *
 * QA: ?kn_popup=<id> [&kn_popup_v=<variant>] [&kn_popup_reset=1] forceert de modal en negeert 2-4.
 *     Events uit zo'n sessie krijgen "qa":1.
 */
(function (w, d) {
  'use strict';
  var cfgEl = d.getElementById('kn-popup-config');
  if (!cfgEl || w.KNPopup) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var CTX = CFG.ctx || {}, POPUPS = CFG.popups || [];
  if (!POPUPS.length) return;

  var REDUCE = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var Q = new URLSearchParams(location.search);
  var FORCE = Q.get('kn_popup'), FORCE_V = Q.get('kn_popup_v');
  var LS = safeStore('localStorage'), SS = safeStore('sessionStorage');

  function safeStore(n) {
    try { var s = w[n], k = '__kn_t'; s.setItem(k, '1'); s.removeItem(k); return s; }
    catch (e) { var m = {}; return { getItem: function (k) { return k in m ? m[k] : null; }, setItem: function (k, v) { m[k] = String(v); }, removeItem: function (k) { delete m[k]; } }; }
  }
  function merge(a, b) { var o = {}, k; for (k in a) o[k] = a[k]; for (k in (b || {})) o[k] = b[k]; return o; }
  function el(tag, cls, txt) { var x = d.createElement(tag); if (cls) x.className = cls; if (txt != null) x.textContent = txt; return x; }

  /* ---------- sessie: paginateller en landingsbron (eerste pagina van de sessie) ---------- */
  var pv = (parseInt(SS.getItem('kn_pop_pv'), 10) || 0) + 1; SS.setItem('kn_pop_pv', pv);
  var SOURCE = SS.getItem('kn_pop_src'), LANDING = false;
  if (!SOURCE) {
    LANDING = true;
    var us = (Q.get('utm_source') || '').toLowerCase(), um = (Q.get('utm_medium') || '').toLowerCase();
    var ref = ''; try { ref = d.referrer ? new URL(d.referrer).hostname : ''; } catch (e) {}
    var internal = ref && ref.replace(/^www\./, '') === location.hostname.replace(/^www\./, '');
    var hasUtm = !!(us || um || Q.get('utm_campaign'));
    if (us === 'klaviyo' || Q.get('_kx') || um === 'email') SOURCE = 'email';
    else if (!hasUtm && /(^|\.)(google|bing|duckduckgo|yahoo|ecosia|startpage)\./.test(ref)) SOURCE = 'search';
    else if (/^(fb|ig|an|facebook|instagram|tiktok|meta|msg|th)$/.test(us) || /(facebook|instagram|tiktok|t\.co|twitter|x\.com|pinterest|snapchat|youtube)/.test(ref)) SOURCE = 'social';
    else if (!ref || internal) SOURCE = hasUtm ? 'other' : 'direct';
    else SOURCE = 'other';
    SS.setItem('kn_pop_src', SOURCE);
    if (SOURCE === 'email') SS.setItem('kn_pop_from_email', '1');
  }
  var FROM_EMAIL = SS.getItem('kn_pop_from_email') === '1';
  var DEVICE = (w.matchMedia && w.matchMedia('(max-width: 767px), (pointer: coarse) and (max-width: 1024px)').matches) ? 'mobile' : 'desktop';

  if (FORCE && Q.get('kn_popup_reset') === '1') {
    ['kn_pop_sub_', 'kn_pop_closed_'].forEach(function (p) { LS.removeItem(p + FORCE); });
    SS.removeItem('kn_pop_var_' + FORCE); SS.removeItem('kn_pop_u_' + FORCE);
  }

  /* ---------- advertentieconversie bij een inschrijving (Tufan 13-10: "also the pop-ups, for meta tiktok google") ----------
     Zelfde aanpak als de landers (tools/lx/kn-lx.js adConversie): de Klaviyo-pop-ups zijn vervangen, en in GTM vuren de
     lead-conversies alleen op Klaviyo-formulieren, dus Google, Meta en TikTok zagen deze inschrijvingen niet.
     - Meta: Shopify's eigen pixel zet window.fbq in de pagina; ontbreekt die (geen toestemming), dan laden we hem zelf.
     - TikTok: Shopify's TikTok-pixel draait in een sandbox zonder window.ttq; we laden de SDK pas bij de conversie.
     - Google Ads: gtag-conversie met hetzelfde label als de landers + enhanced conversions; plus GA4 generate_lead.
     - Eén keer per pop-up per 30 dagen; zelfde event-id op alle platforms (deduplicatie). Nooit bij een geforceerde QA-test. */
  function loadJs(src) { var js = d.createElement('script'); js.async = true; js.src = src; (d.head || d.documentElement).appendChild(js); }
  /* ?kn_test=1: zelfde testmodus als de BF-lander (sessionStorage kn_test). Klaviyo wel, advertentieconversies niet. */
  var TEST = false;
  try { var qt = Q.get('kn_test'); if (qt === '1') SS.setItem('kn_test', '1'); if (qt === '0') SS.removeItem('kn_test'); TEST = SS.getItem('kn_test') === '1'; } catch (e) {}
  function adConversion(pop, email) {
    if (FORCE) return;
    if (TEST) { try { (w.dataLayer = w.dataLayer || []).push({ event: 'kn_popup_test_conversion', test: true, kn_popup_id: pop.id }); } catch (e) {} return; }
    var key = 'kn_pop_conv_' + pop.id;
    try { var prev = JSON.parse(LS.getItem(key) || 'null'); if (prev && Date.now() - prev.t < 30 * 864e5) return; } catch (e) {}
    var id; try { id = (w.crypto && w.crypto.randomUUID) ? w.crypto.randomUUID() : 'kp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10); } catch (e) { id = 'kp-' + Date.now(); }
    try { LS.setItem(key, JSON.stringify({ t: Date.now(), id: id })); } catch (e) {}
    var name = pop.name || pop.id, src = 'kn-popup:' + pop.id + ':' + pop.v;
    try { (w.dataLayer = w.dataLayer || []).push({ event: 'generate_lead', lead_source: src, event_id: id }); } catch (e) {}
    try {
      if (!w.fbq && CTX.fbPixel) {
        var n = w.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!w._fbq) w._fbq = n; n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        loadJs('https://connect.facebook.net/en_US/fbevents.js'); n('init', CTX.fbPixel);
      }
      if (w.fbq) w.fbq('track', 'Lead', { content_name: name, content_category: src }, { eventID: id });
    } catch (e) {}
    try {
      if (CTX.ttPixel) {
        if (!(w.ttq && w.ttq.track)) {
          w.TiktokAnalyticsObject = 'ttq'; var t = w.ttq = w.ttq || [];
          t.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
          t.setAndDefer = function (o, m) { o[m] = function () { o.push([m].concat([].slice.call(arguments, 0))); }; };
          for (var i = 0; i < t.methods.length; i++) t.setAndDefer(t, t.methods[i]);
          var u = 'https://analytics.tiktok.com/i18n/pixel/events.js', e2 = CTX.ttPixel;
          t._i = t._i || {}; t._i[e2] = []; t._i[e2]._u = u; t._t = t._t || {}; t._t[e2] = +new Date(); t._o = t._o || {}; t._o[e2] = {};
          loadJs(u + '?sdkid=' + e2 + '&lib=ttq');
        }
        if (email) w.ttq.identify({ email: email });
        w.ttq.track('CompleteRegistration', { content_name: name }, { event_id: id });
      }
    } catch (e) {}
    try {
      if (CTX.gadsLead) {
        var aw = CTX.gadsLead.split('/')[0];
        w.dataLayer = w.dataLayer || [];
        if (!w.gtag) w.gtag = function () { w.dataLayer.push(arguments); };
        if (!w.__knGadsBoot) { w.__knGadsBoot = 1; loadJs('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(aw)); w.gtag('js', new Date()); w.gtag('config', aw, { allow_enhanced_conversions: true }); }
        if (email) w.gtag('set', 'user_data', { email: email });
        w.gtag('event', 'conversion', { send_to: CTX.gadsLead, transaction_id: id });
      }
    } catch (e) {}
  }

  /* ---------- events: gebundeld naar /apps/kn/e, plus dataLayer en Clarity ---------- */
  var queue = [], flushT = 0;
  function track(pop, e, extra) {
    var ev = { p: pop.id, v: pop.v, e: e, u: 0, d: DEVICE, t: CTX.template || 'other', s: SOURCE || 'other' };
    if (extra) for (var xk in extra) ev[xk] = extra[xk];
    if (e === 'view' && !SS.getItem('kn_pop_u_' + pop.id)) { SS.setItem('kn_pop_u_' + pop.id, '1'); ev.u = 1; }
    if (pop.forced) ev.qa = 1;
    queue.push(ev);
    if (queue.length >= 25) flush(); else { clearTimeout(flushT); flushT = setTimeout(flush, 1500); }
    try { (w.dataLayer = w.dataLayer || []).push({ event: 'kn_popup_' + e, kn_popup_id: pop.id, kn_popup_variant: pop.v }); } catch (x) {}
    try { if (typeof w.clarity === 'function') { w.clarity('set', 'kn_popup', pop.id + ':' + pop.v); w.clarity('event', 'kn_popup_' + e); } } catch (x) {}
    if (pop.forced && w.console) console.info('[kn-popup]', e, ev);
  }
  function flush() {
    clearTimeout(flushT);
    if (!queue.length || !CTX.endpoint) return;
    var body = JSON.stringify({ events: queue.splice(0, 25) });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(CTX.endpoint, body)) { if (queue.length) flush(); return; }
    } catch (e) {}
    try { fetch(CTX.endpoint, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin' }).catch(function () {}); } catch (e) {}
    if (queue.length) flush();
  }
  w.addEventListener('pagehide', flush);
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') flush(); });

  /* ---------- kiezen, toetsen, onderdrukken ---------- */
  function pickVariant(p) {
    var vs = (p.variants && p.variants.length) ? p.variants : [{ id: 'A', weight: 100, overrides: {} }];
    var want = (FORCE === p.id && FORCE_V) || SS.getItem('kn_pop_var_' + p.id), v = null, i;
    for (i = 0; i < vs.length; i++) if (vs[i].id === want) v = vs[i];
    if (!v) {
      var tot = 0, r; for (i = 0; i < vs.length; i++) tot += Math.max(0, +vs[i].weight || 0);
      r = Math.random() * (tot || 1);
      for (i = 0; i < vs.length; i++) { r -= Math.max(0, +vs[i].weight || 0); if (r < 0) { v = vs[i]; break; } }
      v = v || vs[0];
    }
    SS.setItem('kn_pop_var_' + p.id, v.id);
    /* overrides mag genest ({copy:{…},triggers:{…}}) of plat ({headline:…, delaySec:…}); een platte sleutel
       gaat naar copy of triggers, afhankelijk van waar hij in de basisconfig staat. */
    var o = v.overrides || {}, oc = merge(o.copy), ot = merge(o.triggers), k, out = merge(p, {});
    /* type/layout per variant (Tufan, 12-10): zo kan het kaartspel als B-variant naast de kraskaart draaien,
       met dezelfde planning, frequentie en statistiek per variant. */
    for (k in o) if (k !== 'copy' && k !== 'triggers' && k !== 'scratch' && k !== 'type' && k !== 'layout') { if (p.triggers && k in p.triggers) ot[k] = o[k]; else oc[k] = o[k]; }
    if (o.type) out.type = o.type;
    if (o.layout) out.layout = o.layout;
    out.v = v.id;
    if (o.scratch) out.scratch = merge(p.scratch, o.scratch);   /* krasgedrag per variant (A/B op moeite) */
    out.copy = merge(p.copy, oc);
    out.triggers = merge(p.triggers, ot);
    return out;
  }
  function globMatch(list, val) {
    return (list || []).some(function (g) { return g.slice(-1) === '*' ? val.indexOf(g.slice(0, -1)) === 0 : g === val; });
  }
  function eligible(p) {
    if (!p.enabled) return false;
    var now = Date.now();
    if (p.startsAt && now < Date.parse(p.startsAt)) return false;
    if (p.endsAt && now >= Date.parse(p.endsAt)) return false;
    var t = p.targeting || {};
    if (globMatch(t.excludeTemplates, CTX.template || '')) return false;
    if ((t.excludeLayouts || []).indexOf(CTX.layout) > -1) return false;
    if (t.devices && t.devices.length && t.devices.indexOf(DEVICE) < 0) return false;
    if (t.countries && t.countries.length && CTX.country && t.countries.indexOf(CTX.country) < 0) return false;
    return true;
  }
  function suppressed(p) {
    var s = p.suppress || {}, f = p.frequency || {};
    if (LS.getItem('kn_pop_sub_' + p.id)) return true;
    /* al op dezelfde Klaviyo-lijst gezet via een lander of een andere pop-up (kn_lead_<lijst>, o.a. de BF-lander) */
    if (p.klaviyoListId && LS.getItem('kn_lead_' + p.klaviyoListId)) return true;
    var c = parseInt(LS.getItem('kn_pop_closed_' + p.id), 10);
    if (c && Date.now() - c < (f.afterCloseDays != null ? +f.afterCloseDays : 3) * 864e5) return true;
    if (s.fromKlaviyoEmail !== false && FROM_EMAIL) return true;
    if (s.subscribedCustomer !== false && CTX.subscribedCustomer) return true;
    return false;
  }
  /* Klaviyo kent de bezoeker al? Nieuwe API geeft een Promise, oude een boolean; max 1,5 s wachten. */
  function klaviyoKnows() {
    return new Promise(function (res) {
      var done = false, fin = function (v) { if (!done) { done = true; res(!!v); } };
      setTimeout(function () { fin(false); }, 1500);
      try {
        var k = w.klaviyo;
        if (k && typeof k.isIdentified === 'function') { var r = k.isIdentified(); if (r && r.then) r.then(fin, function () { fin(false); }); else fin(r); }
        else fin(false);
      } catch (e) { fin(false); }
    });
  }

  /* ---------- css: pas laden als er echt iets te tonen valt ---------- */
  var cssP = null;
  function loadCss() {
    if (cssP) return cssP;
    cssP = new Promise(function (res) {
      var l = d.createElement('link'); l.rel = 'stylesheet'; l.href = CTX.css; l.onload = l.onerror = function () { res(); };
      d.head.appendChild(l); setTimeout(res, 2500);
    });
    return cssP;
  }
  var scratchP = null;
  function loadScratch() {
    if (scratchP) return scratchP;
    scratchP = new Promise(function (res) {
      if (w.KNScratch) return res(w.KNScratch);
      var s = d.createElement('script'); s.src = CTX.scratchJs; s.async = true;
      s.onload = function () { res(w.KNScratch || null); }; s.onerror = function () { res(null); };
      d.head.appendChild(s);
    });
    return scratchP;
  }

  /* match_cards: kaartjesspel (kn-popup-match.js), ook pas laden als de pop-up opent */
  var matchP = null;
  function loadMatch() {
    if (matchP) return matchP;
    matchP = new Promise(function (res) {
      if (w.KNMatch) return res(w.KNMatch);
      var s = d.createElement('script'); s.src = CTX.matchJs; s.async = true;
      s.onload = function () { res(w.KNMatch || null); }; s.onerror = function () { res(null); };
      d.head.appendChild(s);
    });
    return matchP;
  }

  /* ---------- teaser ---------- */
  function teaser(p, open, close) {
    var t = el('div', 'kn-pop-teaser'); t.setAttribute('data-kn-pop-teaser', p.id);
    var b = el('button', 'kn-pop-teaser__btn'); b.type = 'button';
    b.appendChild(el('span', 'kn-pop-teaser__txt', p.copy.teaser || ''));
    var x = el('button', 'kn-pop-teaser__x'); x.type = 'button'; x.setAttribute('aria-label', 'Sluiten'); x.innerHTML = ICON_X;
    b.addEventListener('click', function () { open('teaser'); });
    x.addEventListener('click', function () { close('teaser'); });
    t.appendChild(b); t.appendChild(x);
    return t;
  }

  /* ---------- modal ---------- */
  var ICON_X = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var ICON_CHECK = '<svg class="kn-pop__ck" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"/></svg>';
  var ICON_CHEV = '<svg class="kn-pop__chev" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* *woord* in kop of onthulling = accent (sky-blue), zoals "70%" op de lander. Tekstknopen, dus geen HTML-injectie. */
  function esc(u) { return String(u).replace(/[&"<>]/g, function (ch) { return { '&': '&amp;', '"': '&quot;', '<': '&lt;', '>': '&gt;' }[ch]; }); }
  function accent(node, txt) {
    var parts = String(txt || '').split('*');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      if (i % 2) node.appendChild(el('em', '', parts[i])); else node.appendChild(d.createTextNode(parts[i]));
    }
  }

  /* "Zet in agenda" in de bevestiging (Tufan, 11-10). copy.calendar = { title, start, end (ISO, UTC), reminderMin,
     url, button, googleLabel }. .ics voor Apple/Outlook (zelfde opbouw als bootIcs op de lander, tijden in UTC zodat
     elke agenda hem in de eigen tijdzone zet) en een Google Agenda-link. Zonder copy.calendar geen knop. */
  function calendar(box, cal) {
    if (!box || !cal || !cal.start) return;
    var s0 = Date.parse(cal.start), s1 = Date.parse(cal.end || '') || (s0 + 30 * 60000);
    if (isNaN(s0)) return;
    var title = cal.title || d.title, url = cal.url || location.origin, rem = +cal.reminderMin || 15;
    function ts(t) { return new Date(t).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
    function esc(x) { return String(x).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
    var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Kosso Nutrition//kn-popup//NL', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
      'BEGIN:VEVENT', 'UID:kn-popup-' + ts(s0) + '@kossonutrition.nl', 'DTSTAMP:' + ts(Date.now()), 'DTSTART:' + ts(s0), 'DTEND:' + ts(s1),
      'SUMMARY:' + esc(title), 'DESCRIPTION:' + esc(url), 'URL:' + url,
      'BEGIN:VALARM', 'TRIGGER:-PT' + rem + 'M', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(title), 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    var a = box.querySelector('[data-kn-pop-ics]'), g = box.querySelector('[data-kn-pop-gcal]');
    var href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
    try { if (w.Blob && w.URL && w.URL.createObjectURL) href = w.URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' })); } catch (e) {}
    a.href = href; a.textContent = cal.button || 'Zet in agenda';
    g.href = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(title) +
      '&dates=' + ts(s0) + '/' + ts(s1) + '&details=' + encodeURIComponent(url) + '&ctz=Europe%2FAmsterdam';
    g.textContent = cal.googleLabel || 'Of in Google Agenda';
    var push = function (k) { return function () { try { (w.dataLayer = w.dataLayer || []).push({ event: 'kn_popup_calendar', kn_popup_calendar: k }); } catch (e) {} }; };
    a.addEventListener('click', push('ics')); g.addEventListener('click', push('google'));
    box.hidden = false;
  }

  /* Opbouw (11-10-2026, Tufan: "matchen met de 7-jarig-bestaan landingspagina"): dezelfde poster als
     /pages/7-jarig-bestaan. Zwart, haaks, witte kicker, condensed kapitalen met één sky-blue accent, een
     vlakke kraslaag met een haarlijn-voortgang zoals de klokbalk, het witte veld + groene knop met chevron
     en drie puntjes, en de bevestiging met het sky-blue streepje. Geen badge, glans, burst of zwaaiend handje.
     Tekst in div's, niet in <p>: Dev_styles.css zet p { font-weight:400 !important } winkelbreed. */
  function icsName(cal) {
    var t = String((cal && cal.title) || 'kosso-nutrition').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48);
    return (t || 'kosso-nutrition') + '.ics';
  }

  /* Keuzestap (type choice): tegels uit copy.choices = [{ value, title, text, image }], max 3. Eén tik = gekozen (de
     tegel wordt geel, geen vinkje), daarna "Volgende" naar het e-mailveld. Echte radioknoppen in een fieldset, dus
     pijltjestoetsen en schermlezers werken zonder extra script. Beelden: URL of kale thema-assetnaam. */
  function choiceStep(p, id, au) {
    var c = p.copy || {}, list = (c.choices || []).filter(function (x) { return x && x.value && x.title; }).slice(0, 3);
    var box = el('div', 'kn-pop__choice'); box.setAttribute('data-kn-pop-choice', '');
    /* Aanbodblok bovenaan stap 1 (copy.promo groot, copy.promoSub eronder): de reden om te klikken staat vóór de vraag. */
    if (c.promo) {
      var pr = el('div', 'kn-pop__promo'); pr.appendChild(el('span', 'kn-pop__promo-big', c.promo));
      if (c.promoSub) pr.appendChild(el('span', 'kn-pop__promo-sub', c.promoSub));
      box.appendChild(pr);
    }
    if (c.choiceEyebrow) box.appendChild(el('div', 'kn-pop__eyebrow', c.choiceEyebrow));
    var h = el('h2', 'kn-pop__h'); h.id = id + '-ch'; accent(h, c.choiceHeadline || c.headline); box.appendChild(h);
    if (c.choiceSub) box.appendChild(el('div', 'kn-pop__sub', c.choiceSub));
    /* copy.choicePrompt: korte opdracht vlak boven de tegels ("Kies wat bij je past"), zodat duidelijk is dat er gekozen moet worden. */
    if (c.choicePrompt) { var pp = el('div', 'kn-pop__prompt', c.choicePrompt); pp.id = id + '-cp'; box.appendChild(pp); }
    var fs = el('fieldset', 'kn-pop__tiles'); fs.setAttribute('aria-labelledby', id + '-ch' + (c.choicePrompt ? ' ' + id + '-cp' : ''));
    list.forEach(function (x, i) {
      var lab = el('label', 'kn-pop__tile');
      var r = el('input', 'kn-pop__sr'); r.type = 'radio'; r.name = id + '-c'; r.value = x.value;
      lab.appendChild(r);
      if (x.image) { var im = el('img', 'kn-pop__tile-img'); im.src = au(x.image); im.alt = ''; im.decoding = 'async'; im.width = 120; im.height = 120; lab.appendChild(im); }
      var tx = el('span', 'kn-pop__tile-tx'); tx.appendChild(el('span', 'kn-pop__tile-t', x.title)); if (x.text) tx.appendChild(el('span', 'kn-pop__tile-d', x.text));
      lab.appendChild(tx); var rd = el('span', 'kn-pop__tile-r'); rd.setAttribute('aria-hidden', 'true'); lab.appendChild(rd); fs.appendChild(lab);
    });
    box.appendChild(fs);
    var foot = el('div', 'kn-pop__choice-foot');
    if (c.choiceNote) {
      var nt = el('div', 'kn-pop__note', c.choiceNote);
      /* copy.giftUrl: link naar de cadeauvoorwaarden achter de kleine lettertjes (stap 1) en de toestemmingsregel (stap 2). */
      if (c.giftUrl) { nt.appendChild(d.createTextNode(' ')); var gl = el('a', '', c.giftLabel || 'Voorwaarden'); gl.href = c.giftUrl; gl.target = '_blank'; gl.rel = 'noopener'; nt.appendChild(gl); }
      foot.appendChild(nt);
    }
    var nx = el('button', 'kn-pop__btn kn-pop__next'); nx.type = 'button'; nx.disabled = true; nx.setAttribute('data-kn-pop-next', '');
    nx.appendChild(el('span', 'kn-pop__btn-txt', c.choiceButton || 'Volgende')); nx.insertAdjacentHTML('beforeend', ICON_CHEV);
    foot.appendChild(nx); box.appendChild(foot);
    if (c.choiceSkip) { var sk = el('button', 'kn-pop__skip', c.choiceSkip); sk.type = 'button'; sk.setAttribute('data-kn-pop-x', ''); box.appendChild(sk); }
    return box;
  }

  function buildModal(p) {
    var c = p.copy || {}, id = 'kn-pop-' + p.id;
    var root = el('div', 'kn-pop'); root.id = id; root.hidden = true;
    root.innerHTML =
      '<div class="kn-pop__backdrop" data-kn-pop-x></div>' +
      '<div class="kn-pop__panel" role="dialog" aria-modal="true" aria-labelledby="' + id + '-h" tabindex="-1">' +
        '<button type="button" class="kn-pop__close" data-kn-pop-x aria-label="Sluiten">' + ICON_X + '</button>' +
        '<div class="kn-pop__bg" aria-hidden="true" hidden></div>' +
        '<div class="kn-pop__hook" hidden></div>' +
        '<div class="kn-pop__eyebrow" hidden></div>' +
        '<h2 class="kn-pop__h" id="' + id + '-h"></h2>' +
        '<div class="kn-pop__sub" hidden></div>' +
        '<div class="kn-pop__card" data-kn-pop-card>' +
          '<div class="kn-pop__reveal" data-kn-pop-reveal></div>' +
          '<div class="kn-pop__reveal-n" hidden></div>' +
          '<span class="kn-pop__label" aria-hidden="true"></span>' +
        '</div>' +
        '<div class="kn-pop__progress" data-kn-pop-progress aria-hidden="true"><i></i></div>' +
        '<div class="kn-pop__row" data-kn-pop-hint>' +
          '<span class="kn-pop__hint"></span>' +
          '<button type="button" class="kn-pop__tap" data-kn-pop-tap></button>' +
        '</div>' +
        '<form class="kn-pop__form" data-kn-pop-form novalidate hidden>' +
          '<label class="kn-pop__sr" for="' + id + '-e"></label>' +
          '<input class="kn-pop__input" id="' + id + '-e" type="email" name="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" required aria-describedby="' + id + '-m">' +
          '<div class="kn-pop__msg" id="' + id + '-m" data-kn-pop-msg role="status" aria-live="polite"></div>' +
          '<button type="submit" class="kn-pop__btn"><span class="kn-pop__btn-txt"></span>' + ICON_CHEV + '<span class="kn-pop__dots" aria-hidden="true"><i></i><i></i><i></i></span></button>' +
          '<div class="kn-pop__consent"></div>' +
        '</form>' +
        '<div class="kn-pop__done" data-kn-pop-done tabindex="-1" hidden>' +
          '<span class="kn-pop__done-rule" aria-hidden="true"></span>' +
          '<div class="kn-pop__done-t" hidden></div>' +
          '<div class="kn-pop__done-b"></div>' +
          '<div class="kn-pop__cal" hidden>' +
            '<a class="kn-pop__cal-btn" data-kn-pop-ics download="' + esc(icsName(c.calendar)) + '"></a>' +
            '<a class="kn-pop__cal-g" data-kn-pop-gcal target="_blank" rel="noopener"></a>' +
          '</div>' +
        '</div>' +
      '</div>';
    var q = function (sel) { return root.querySelector(sel); };
    /* layout "fullscreen" (Tufan, 11-10): pop-up over het hele scherm met een beeld erachter. copy.bgMobile/bgDesktop =
       sfeerbeeld (bv. uit Higgsfield), copy.packshot = productfoto die gekanteld in de hoek staat (als er geen
       sfeerbeeld is, of erbovenop). Decoratief, dus aria-hidden; een donkere scrim houdt kop en kaarten leesbaar. */
    if (p.layout === 'fullscreen') {
      root.classList.add('kn-pop--full');
      var bg = q('.kn-pop__bg'), h = '';
      /* de app kent geen asset_url: een kale bestandsnaam ("kn-match3-bg-mobile.webp") wordt een thema-asset */
      var au = function (u) { return u && !/[\/:]/.test(u) ? (CTX.assetBase || '') + u : u; };
      c.bgMobile = au(c.bgMobile); c.bgDesktop = au(c.bgDesktop); c.packshot = au(c.packshot);
      if (c.bgMobile || c.bgDesktop) {
        h += '<picture>' + (c.bgDesktop ? '<source media="(min-width: 768px)" srcset="' + esc(c.bgDesktop) + '">' : '') +
             '<img class="kn-pop__bg-img" src="' + esc(c.bgMobile || c.bgDesktop) + '" alt="" decoding="async"></picture>';
      }
      if (c.packshot) h += '<img class="kn-pop__pack" src="' + esc(c.packshot) + '" alt="" decoding="async">';
      bg.innerHTML = h + '<span class="kn-pop__scrim"></span>';
      bg.hidden = false;
    }
    /* layout "bf": BF26-huisstijl. Beelden in de tegels mogen een kale thema-assetnaam zijn, net als bij fullscreen. */
    if (p.layout === 'bf') root.classList.add('kn-pop--bf');
    if (c.doneButton) { var db = el('button', 'kn-pop__btn kn-pop__done-x', c.doneButton); db.type = 'button'; db.setAttribute('data-kn-pop-x', ''); q('[data-kn-pop-done]').appendChild(db); }
    accent(q('.kn-pop__h'), c.headline);
    if (c.eyebrow) { q('.kn-pop__eyebrow').textContent = c.eyebrow; q('.kn-pop__eyebrow').hidden = false; }
    /* copy.hook = de grootste extra prikkel als opvallende sky-blue strook boven de kop (Tufan, 11-10: "de 1000x
       gratis pre-workout springt er niet uit"); copy.sub = korte uitlegregel onder de kop. */
    if (c.hook) { q('.kn-pop__hook').textContent = c.hook; q('.kn-pop__hook').hidden = false; }
    if (c.sub) { q('.kn-pop__sub').textContent = c.sub; q('.kn-pop__sub').hidden = false; }
    /* copy.perks: korte voordelen als vinkjeslijst i.p.v. een alinea (Tufan 30-10 02:05: "teveel losse paragraaf tekst").
       Drie plekken: onder de uitleg (keuzestap 2), in de kaart na de onthulling (kraskaart/kaartspel) en in de bevestiging.
       copy.perksNote = kleine regel eronder, met de cadeauvoorwaarden-link (giftUrl/giftLabel). */
    if (c.perks && c.perks.length) {
      var mk = function (where) {
        var wrap = el('div', 'kn-pop__perks kn-pop__perks--' + where), ul = el('ul', 'kn-pop__perks-l');
        c.perks.slice(0, 5).forEach(function (t) { if (!t) return; var li = el('li'); li.insertAdjacentHTML('afterbegin', ICON_CHECK); li.appendChild(el('span', '', t)); ul.appendChild(li); });
        wrap.appendChild(ul);
        if (c.perksNote || c.giftUrl) {
          var pn = el('div', 'kn-pop__pnote', c.perksNote || '');
          if (c.giftUrl) { if (c.perksNote) pn.appendChild(d.createTextNode(' · ')); var ga = el('a', '', c.giftLabel || 'Voorwaarden'); ga.href = c.giftUrl; ga.target = '_blank'; ga.rel = 'noopener'; pn.appendChild(ga); }
          wrap.appendChild(pn);
        }
        return wrap;
      };
      q('.kn-pop__sub').insertAdjacentElement('afterend', mk('main'));
      q('[data-kn-pop-card]').appendChild(mk('card'));
      q('.kn-pop__done-b').insertAdjacentElement('afterend', mk('done'));
    }
    accent(q('[data-kn-pop-reveal]'), c.reveal);
    /* copy.revealNote: kleine regel onder de onthulling (kraskaart/kaartspel), bijv. wat er om 19:00 nieuw is (Tufan 30-10 02:00). */
    if (c.revealNote) { q('.kn-pop__reveal-n').textContent = c.revealNote; q('.kn-pop__reveal-n').hidden = false; }
    q('.kn-pop__hint').textContent = c.scratchHint || '';
    q('.kn-pop__label').textContent = c.scratchHint || '';
    q('[data-kn-pop-tap]').textContent = c.tapAlt || 'Tik om te onthullen';
    q('.kn-pop__sr').textContent = c.emailLabel || 'E-mailadres';
    q('.kn-pop__input').placeholder = c.emailPlaceholder || 'jouw@email.nl';
    q('.kn-pop__btn-txt').textContent = c.button || 'Aanmelden';
    if (c.successTitle) { q('.kn-pop__done-t').textContent = c.successTitle; q('.kn-pop__done-t').hidden = false; }
    q('.kn-pop__done-b').textContent = c.success || '';
    calendar(q('.kn-pop__cal'), c.calendar);
    var cons = q('.kn-pop__consent'); cons.textContent = (c.consent || '') + ' ';
    if (c.termsUrl) { var a = el('a', '', c.termsLabel || 'Voorwaarden'); a.href = c.termsUrl; a.target = '_blank'; a.rel = 'noopener'; cons.appendChild(a); }
    if (c.giftUrl && c.giftLabelConsent) { cons.appendChild(d.createTextNode(' · ')); var ga = el('a', '', c.giftLabelConsent); ga.href = c.giftUrl; ga.target = '_blank'; ga.rel = 'noopener'; cons.appendChild(ga); }
    /* keuzestap pas als laatste invoegen: hij gebruikt dezelfde klassen (kop, knop), en de q()-aanroepen hierboven
       moeten de elementen van stap 2 vinden, niet die van de tegels */
    if (p.type === 'choice') {
      var au2 = function (u) { return u && !/[\/:]/.test(u) ? (CTX.assetBase || '') + u : u; };
      var panel = q('.kn-pop__panel'), ch = choiceStep(p, id, au2);
      panel.insertBefore(ch, q('.kn-pop__bg'));
      panel.setAttribute('aria-labelledby', id + '-ch');
      var back = el('button', 'kn-pop__back', c.backLabel || '\u2190 Terug'); back.type = 'button'; back.setAttribute('data-kn-pop-back', '');
      panel.insertBefore(back, q('[data-kn-pop-form]').nextSibling);
      root.classList.add('kn-pop--choice', 'is-step1');
    }
    return root;
  }

  function run(p, forced) {
    p.forced = forced;
    /* zolang onze pop-up op deze pagina draait, geen Klaviyo-pop-up ernaast (regel in kn-popup.css) */
    d.documentElement.classList.add('kn-pop-on');
    loadCss();
    var modal = null, tz = null, opened = false, gone = false, lastFocus = null, revealed = false, scratch = null, chosen = '';
    /* krasgedrag; overschrijfbaar via p.scratch in de config. Was: 50 %, kwast 16 %, formulier direct. */
    var SC = { threshold: 0.7, brush: 0.11, formDelayMs: 1100 };
    if (p.scratch) for (var sk in SC) if (p.scratch[sk] != null && !isNaN(+p.scratch[sk])) SC[sk] = +p.scratch[sk];

    function close(how) {
      if (gone) return;
      gone = true;
      if (!LS.getItem('kn_pop_sub_' + p.id)) { LS.setItem('kn_pop_closed_' + p.id, String(Date.now())); track(p, 'close'); }
      if (tz && tz.parentNode) tz.parentNode.removeChild(tz);
      if (modal) {
        modal.classList.remove('is-in');
        d.documentElement.classList.remove('kn-pop-lock');
        noFocusZoom(false);
        d.removeEventListener('keydown', onKey, true);
        modal.classList.add('is-out');
        setTimeout(function () { if (modal) modal.hidden = true; }, REDUCE ? 0 : 180);
        if (scratch && scratch.destroy) scratch.destroy();
        if (lastFocus && lastFocus.focus && d.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      }
    }
    function onKey(e) {
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(modal.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])')).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = d.activeElement;
      if (!modal.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
    function doReveal(how) {
      if (revealed) return;
      revealed = true;
      var q = function (s) { return modal.querySelector(s); };
      var card = q('[data-kn-pop-card]'), tap = q('[data-kn-pop-tap]'), form = q('[data-kn-pop-form]');
      card.classList.add('is-revealed');
      modal.classList.add('is-revealed');
      q('[data-kn-pop-reveal]').removeAttribute('aria-hidden');
      if (tap) tap.hidden = true;
      var hint = q('[data-kn-pop-hint]'), prog = q('[data-kn-pop-progress]');
      if (hint) hint.hidden = true;
      if (prog) prog.hidden = true;
      if (scratch && scratch.clear) scratch.clear(REDUCE);
      if (p.type === 'reveal_scratch' || p.type === 'match_cards') track(p, 'reveal');
      /* Eerst het moment, dan pas het formulier (Tufan, 11-10: "te snel"). Na krassen SC.formDelayMs, na de tik-knop
         de helft, bij reduced motion of zonder kraskaart meteen. */
      /* match_cards: het winmoment (3 op een rij + confetti) speelde al in het raster, dus meteen door naar de claim
         (Tufan, 12-10). */
      var wait = (REDUCE || how === 'auto') ? 0 : how === 'match' ? 200 : how === 'tap' ? Math.round(SC.formDelayMs / 2) : SC.formDelayMs;
      setTimeout(function () {
        if (gone) return;
        form.hidden = false;
        var inp = form.querySelector('input');
        /* focus naar het veld alleen na de tik-knop; na krassen niet (het toetsenbord schuift anders over de onthulling) */
        if (how === 'tap' && inp) { try { inp.focus({ preventScroll: true }); } catch (e) {} }
      }, wait);
    }
    /* choice: stap 1 = tegels, "Volgende" = stap 2 (formulier). reveal-event = stap 1 gehaald, met de keuze erbij. */
    function wireChoice() {
      var q = function (s) { return modal.querySelector(s); };
      var nx = q('[data-kn-pop-next]'), form = q('[data-kn-pop-form]'), back = q('[data-kn-pop-back]');
      /* Auto-door (Tufan 30-10 01:58): tik/klik op een tegel → kort de gekozen staat (geel + vinkje) → vanzelf naar stap 2.
         Alleen bij aanwijzer of tik; met het toetsenbord (pijltjes wisselen de keuze) blijft "Volgende" de stap, anders
         spring je bij elke pijl weg. */
      var ptr = 0, advT = 0, RM = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
      [].forEach.call(modal.querySelectorAll('.kn-pop__tile'), function (t) {
        t.addEventListener('pointerdown', function () { ptr = Date.now(); });
        t.addEventListener('keydown', function () { ptr = 0; });
        /* na "Terug" dezelfde tegel nog eens aantikken: geen change-event (al gekozen), dus hier ook door */
        t.addEventListener('click', function () { var r = t.querySelector('input'); if (r && r.checked && chosen === r.value && Date.now() - ptr < 1000) { clearTimeout(advT); advT = setTimeout(next, RM ? 120 : 320); } });
      });
      [].forEach.call(modal.querySelectorAll('.kn-pop__tile input'), function (r) {
        r.addEventListener('change', function () {
          chosen = r.value; nx.disabled = false;
          [].forEach.call(modal.querySelectorAll('.kn-pop__tile'), function (t) { t.classList.toggle('is-on', t.contains(r)); });
          clearTimeout(advT);
          if (Date.now() - ptr < 1000) advT = setTimeout(next, RM ? 120 : 320);
        });
      });
      nx.addEventListener('click', next);
      function next() {
        clearTimeout(advT);
        if (modal.classList.contains('is-step2')) return;
        if (!chosen) return;
        modal.classList.remove('is-step1'); modal.classList.add('is-step2');
        form.hidden = false;
        if (!revealed) { revealed = true; track(p, 'reveal', { c: chosen }); }
        try { (w.dataLayer = w.dataLayer || []).push({ event: 'kn_popup_choice', kn_popup_id: p.id, kn_popup_choice: chosen }); } catch (e) {}
        var inp = form.querySelector('input'); try { inp.focus({ preventScroll: true }); } catch (e) {}
        q('.kn-pop__panel').scrollTop = 0;
      }
      if (back) back.addEventListener('click', function () {
        modal.classList.remove('is-step2'); modal.classList.add('is-step1');
        var on = modal.querySelector('.kn-pop__tile input:checked') || modal.querySelector('.kn-pop__tile input');
        try { on.focus({ preventScroll: true }); } catch (e) {}
      });
    }
    function wireForm() {
      var form = modal.querySelector('[data-kn-pop-form]'), inp = form.querySelector('input'), btn = form.querySelector('button'), msg = form.querySelector('[data-kn-pop-msg]');
      var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      function bad(t) { msg.textContent = t; msg.className = 'kn-pop__msg is-err'; inp.setAttribute('aria-invalid', 'true'); form.classList.add('is-err'); }
      function good() { msg.textContent = ''; msg.className = 'kn-pop__msg'; inp.removeAttribute('aria-invalid'); form.classList.remove('is-err'); }
      /* valideren bij verlaten van het veld (niet bij elke toets), foutmelding direct onder het veld */
      inp.addEventListener('blur', function () { var v = (inp.value || '').trim(); if (v && !RE.test(v)) bad('Vul een geldig e-mailadres in.'); });
      inp.addEventListener('input', function () { if (inp.getAttribute('aria-invalid') && RE.test((inp.value || '').trim())) good(); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (inp.value || '').trim();
        if (!RE.test(email)) { bad('Vul een geldig e-mailadres in.'); inp.focus(); return; }
        good();
        btn.disabled = true; btn.classList.add('is-busy');
        var src = (p.customSourcePrefix || 'kn-popup') + ':' + p.id + ':' + p.v;
        var props = { 'KN Popup ID': p.id, 'KN Popup Variant': p.v, 'KN Signup Page': location.pathname };
        if (chosen) props[(p.copy && p.copy.choiceProp) || 'KN Popup Choice'] = chosen;
        /* BF26 (Tufan 4-11): pop-up en lander op dezelfde lijst, per bron/variant/route te tellen. */
        var isBf = p.klaviyoListId === 'SY3g4X';
        if (isBf) { props.bf26_source = 'popup'; props.bf26_variant = p.v; }
        function withRoute(rt) { var o = {}, k; for (k in props) o[k] = props[k]; if (isBf) o.bf26_route = rt; return o; }
        var direct = (typeof w.knKlSub === 'function') ? w.knKlSub(email, null, src, { listId: p.klaviyoListId, properties: withRoute('client') }) : null;
        if (!direct || !direct.then) direct = Promise.reject(new Error('knKlSub ontbreekt'));
        /* Terugval zoals de BF26-lander (in-app browsers): faalt Klaviyo of duurt het langer dan 8 s, dan via onze eigen
           app-route /apps/kn/signup. Alleen succes bij r.ok en j.ok === true; anders de oorspronkelijke fout. */
        var go = new Promise(function (res, rej) {
          var t = setTimeout(function () { rej(new Error('timeout')); }, 8000);
          direct.then(function (r) { clearTimeout(t); res(r); }, function (e) { clearTimeout(t); rej(e); });
        }).catch(function (e1) {
          if (!p.klaviyoListId) throw e1;
          return fetch('/apps/kn/signup', {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ email: email, list: p.klaviyoListId, source: src, properties: withRoute('server'), website: '' })
          }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) {
              if (r.ok && j && j.ok === true) return { kn: { ok: true, list: 'main', route: 'server' } };
              throw e1;
            });
          }, function () { throw e1; });
        });
        go.then(function (r) {
          /* plafond vol (7-jarig, knKlSub zag full in /apps/kn/cap): het adres staat op de wachtlijst. Geen winst-scherm en geen
             advertentieconversie; de pop-up zegt eerlijk dat het vol is. */
          if (r && r.kn && r.kn.list === 'closed') {
            inp.disabled = true; btn.disabled = true; btn.classList.remove('is-busy');
            msg.textContent = (p.copy && p.copy.closed) || 'Vol = vol. Ronde één en ronde twee zitten allebei vol.';
            msg.className = 'kn-pop__msg is-ok';
            track(p, 'submit_error', { r: 'closed' });
            return;
          }
          if (r && r.kn && r.kn.list === 'waitlist') {
            LS.setItem('kn_pop_sub_' + p.id, String(Date.now()));
            track(p, 'submit', (p.type === 'choice' && chosen) ? { l: 'waitlist', c: chosen } : { l: 'waitlist' });
            inp.disabled = true; btn.classList.remove('is-busy');
            msg.textContent = (p.copy && p.copy.waitlist) || 'Vol = vol. Je staat op ronde twee: woensdag 21 oktober om 19:10 krijg je toegang.';
            msg.className = 'kn-pop__msg is-ok';
            return;
          }
          LS.setItem('kn_pop_sub_' + p.id, String(Date.now()));
          if (p.klaviyoListId) LS.setItem('kn_lead_' + p.klaviyoListId, '1');
          /* type choice: de laatste keuze mee, zodat de app aanmeldingen per keuze telt (app, 30-10). */
          track(p, 'submit', (p.type === 'choice' && chosen) ? { c: chosen } : undefined);
          adConversion(p, email);
          form.hidden = true;
          modal.classList.add('is-done');
          var done = modal.querySelector('[data-kn-pop-done]'); done.hidden = false;
          requestAnimationFrame(function () { done.classList.add('is-in'); });
          try { done.focus({ preventScroll: true }); } catch (x) {}
          if (tz && tz.parentNode) tz.parentNode.removeChild(tz);
        }, function (err) {
          /* r = waarom het misging (afgesproken met @app, 11-10): http_400 | http_429 | http_5xx | network | config.
             knKlSub rejectt met "knKlSub: HTTP <status>", "knKlSub: config", of de TypeError van fetch (netwerk/blocker). */
          var m = String((err && err.message) || ''), st = (m.match(/HTTP (\d{3})/) || [])[1], r;
          if (/config|ontbreekt/.test(m)) r = 'config';
          else if (st) r = st === '429' ? 'http_429' : st.charAt(0) === '5' ? 'http_5xx' : 'http_400';
          else r = 'network';
          track(p, 'submit_error', { r: r });
          btn.disabled = false; btn.classList.remove('is-busy');
          bad((p.copy && p.copy.error) || 'Dat lukte niet. Probeer het nog een keer.');
        });
      });
    }

    function open(via) {
      if (opened || gone) return;
      opened = true;
      loadCss().then(function () {
        if (p.type === 'match_cards') return loadMatch();
        var needScratch = p.type === 'reveal_scratch' && !REDUCE;
        return needScratch ? loadScratch() : null;
      }).then(function (S) {
        if (gone) return;
        modal = buildModal(p);
        d.body.appendChild(modal);
        var q = function (s) { return modal.querySelector(s); };
        [].forEach.call(modal.querySelectorAll('[data-kn-pop-x]'), function (x) { x.addEventListener('click', function () { close('x'); }); });
        wireForm();
        var card = q('[data-kn-pop-card]'), tap = q('[data-kn-pop-tap]');
        if (p.type === 'reveal_scratch') {
          q('[data-kn-pop-reveal]').setAttribute('aria-hidden', 'true');
          tap.addEventListener('click', function () { doReveal('tap'); });
        } else if (p.type === 'match_cards') {
          /* de kaartjes zijn zelf knoppen, dus geen tik-alternatief nodig; hint/voortgang horen bij krassen */
          modal.classList.add('kn-pop--match');
          q('[data-kn-pop-reveal]').setAttribute('aria-hidden', 'true');
          tap.hidden = true; q('[data-kn-pop-hint]').hidden = true; q('[data-kn-pop-progress]').hidden = true;
        } else { tap.hidden = true; card.hidden = !(p.copy && p.copy.reveal); q('[data-kn-pop-hint]').hidden = true; q('[data-kn-pop-progress]').hidden = true; }
        if (p.type === 'choice') wireChoice();
        lastFocus = d.activeElement;
        if (tz) tz.classList.add('is-off');
        modal.hidden = false;
        d.documentElement.classList.add('kn-pop-lock');
        noFocusZoom(true);
        d.addEventListener('keydown', onKey, true);
        /* kraslaag meteen (vóór de eerste paint), anders flitst de onthulling één frame zichtbaar */
        if (p.type === 'reveal_scratch') {
          if (REDUCE || !S) doReveal('auto');
          else {
            var bar = q('[data-kn-pop-progress] i');
            scratch = S.mount(card, { hint: p.copy.scratchHint || '', threshold: SC.threshold, brush: SC.brush,
              onProgress: function (r) { if (bar) bar.style.transform = 'scaleX(' + Math.min(1, r).toFixed(3) + ')'; if (r > 0) modal.classList.add('is-scratching'); },
              onReveal: function () { doReveal('scratch'); } });
          }
        } else if (p.type === 'match_cards') {
          if (!S) doReveal('auto');
          else scratch = S.mount(card, { cards: (p.copy && p.copy.cards) || ['A', 'B', 'C'], win: (p.copy && p.copy.winCard) || '', back: (p.copy && p.copy.cardBack) || '?',
            label: (p.copy && p.copy.cardsLabel) || 'Kaart', reduce: REDUCE, onWin: function () { doReveal('match'); } });
        } else if (p.type !== 'choice') { doReveal('auto'); }
        requestAnimationFrame(function () {
          modal.classList.add('is-in');
          try { q('.kn-pop__panel').focus({ preventScroll: true }); } catch (e) {}
        });
        track(p, 'view');
      });
    }

    /* teaser */
    var trig = p.triggers || {};
    if (trig.teaser && p.copy && p.copy.teaser) {
      loadCss().then(function () {
        if (gone || opened) return;
        tz = teaser(p, open, close);
        d.body.appendChild(tz);
        requestAnimationFrame(function () { tz.classList.add('is-in'); });
        track(p, 'teaser_view');
      });
    }

    if (forced) { setTimeout(function () { open('force'); }, 500); return; }

    /* modal-trigger: niet op een Google-landingspagina, niet vóór minPageviews */
    if (trig.searchLandingTeaserOnly !== false && LANDING && SOURCE === 'search') return;
    if (pv < (+trig.minPageviews || 1)) return;
    var armed = false, delayT = 0;
    function fire() {
      if (armed || opened || gone) return;
      armed = true;
      w.removeEventListener('scroll', onScroll);
      clearTimeout(delayT);
      whenCookieDone(function () {
        var chk = (p.suppress || {}).klaviyoIdentified !== false ? klaviyoKnows() : Promise.resolve(false);
        chk.then(function (known) { if (known) { if (tz && tz.parentNode) tz.parentNode.removeChild(tz); gone = true; return; } open('trigger'); });
      });
    }
    function onScroll() {
      var h = d.documentElement.scrollHeight - w.innerHeight;
      if (h > 0 && ((w.scrollY || 0) / h) * 100 >= (+trig.scrollPct || 101)) fire();
    }
    if (trig.scrollPct != null) w.addEventListener('scroll', onScroll, { passive: true });
    delayT = setTimeout(fire, Math.max(0, +trig.delaySec || 0) * 1000);
  }

  /* Geen inzoomen bij een tik op het e-mailveld (Tufan, 11-10). Het veld is al 16px, maar iOS zoomt soms toch.
     Zolang de pop-up open is, alleen op iOS, krijgt de viewport maximum-scale=1. Sinds iOS 10 negeert Safari dat voor
     knijpen (toegankelijkheid), maar respecteert het voor de automatische focus-zoom. Op Android zou het knijpen wél
     blokkeren, daarom alleen iOS, en bij sluiten gaat de oorspronkelijke viewport terug. */
  var IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var vpOrig = null;
  function noFocusZoom(on) {
    if (!IOS) return;
    var m = d.querySelector('meta[name="viewport"]');
    if (!m) return;
    if (on) { if (vpOrig === null) vpOrig = m.getAttribute('content') || ''; if (!/maximum-scale/.test(vpOrig)) m.setAttribute('content', vpOrig + ', maximum-scale=1'); }
    else if (vpOrig !== null) { m.setAttribute('content', vpOrig); vpOrig = null; }
  }

  /* De cookiebalk (kn-cc) staat onderin vast; de modal wacht tot die weg is. */
  function whenCookieDone(cb) {
    var cc = d.querySelector('.kn-cc');
    var up = function () { return cc && !cc.hasAttribute('hidden') && cc.classList.contains('is-in'); };
    if (!up()) return cb();
    var mo = new MutationObserver(function () { if (!up()) { mo.disconnect(); setTimeout(cb, 400); } });
    mo.observe(cc, { attributes: true, attributeFilter: ['class', 'hidden'] });
  }

  /* ---------- start: één pop-up per pagina (de eerste die mag) ---------- */
  function boot() {
    var i, p;
    if (FORCE) {
      for (i = 0; i < POPUPS.length; i++) if (POPUPS[i].id === FORCE) return run(pickVariant(POPUPS[i]), true);
      return;
    }
    for (i = 0; i < POPUPS.length; i++) {
      p = POPUPS[i];
      if (!eligible(p) || suppressed(p)) continue;
      return run(pickVariant(p), false);
    }
  }
  w.KNPopup = { version: 1 };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})(window, document);
